import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=291ff5be&scoped=true"
import script from "./EventItem.vue?vue&type=script&lang=js"
export * from "./EventItem.vue?vue&type=script&lang=js"
import style0 from "./EventItem.vue?vue&type=style&index=0&id=291ff5be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291ff5be",
  null
  
)

export default component.exports